<template>
  <v-simple-table v-if="top5.length">
    <template v-slot:default>
      <thead>
        <tr>
          <th class="text-right">Место</th>
          <th class="text-left">Участник</th>
          <th class="text-right">Баллы</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(item, index) in top5"
          :key="item.id"
          :class="{ 'my-row': index + 1 === myRank }"
        >
          <td class="text-right">{{ index + 1 }}</td>
          <td>
            {{ item.name }}
            <template v-if="index + 1 === myRank">
              (вы)
            </template>
          </td>
          <td class="text-right">{{ item.score | score }}</td>
        </tr>
        <template v-if="myRank > 5">
          <tr v-if="myRank === 7">
            <td class="text-right">6</td>
            <td colspan="3">&hellip;</td>
          </tr>
          <tr v-if="myRank > 7">
            <td class="text-right">6-{{ myRank - 1 }}</td>
            <td colspan="3">&hellip;</td>
          </tr>
          <tr class="my-row">
            <td class="text-right">{{ myRank }}</td>
            <td>{{ myScore.name }} (вы)</td>
            <td class="text-right">{{ myScore.score | score }}</td>
          </tr>
          <tr v-if="myRank < count - 1">
            <td class="text-right">{{ myRank + 1 }}-{{ count }}</td>
            <td colspan="3">&hellip;</td>
          </tr>
          <tr v-if="myRank === count - 1">
            <td class="text-right">{{ count }}</td>
            <td colspan="3">&hellip;</td>
          </tr>
        </template>
        <template v-else-if="count > 6">
          <tr>
            <td class="text-right">6-{{ count }}</td>
            <td colspan="3">&hellip;</td>
          </tr>
        </template>
      </tbody>
    </template>
  </v-simple-table>
  <p v-else class="mt-5">Недостаточно результатов для построения рейтинга</p>
</template>
<script>
export default {
  name: 'RatingTable',
  props: ['top5', 'myRank', 'myScore', 'count']
}
</script>
<style>
tr.my-row td {
  font-weight: bold;
}
</style>
